import { z } from 'zod';
import { id, organizationId, timestamp } from './common.js';

/**
 * Append-only audit trail for sensitive actions (logins, role changes, credential approvals, shift
 * edits/cancellations, admin overrides). Each entry ties an actor + timestamp to a before/after.
 */
export const auditLog = z.object({
  id,
  organizationId,
  /** Platform user who performed the action; null for system actions. */
  actorUserId: id.nullable(),
  /** e.g. "credential.approved", "shift.cancelled", "membership.role_changed". */
  action: z.string().min(1),
  entityType: z.string().min(1),
  entityId: id.nullable(),
  previousValue: z.record(z.string(), z.unknown()).nullable(),
  newValue: z.record(z.string(), z.unknown()).nullable(),
  ipAddress: z.string().nullable(),
  createdAt: timestamp,
});
export type AuditLog = z.infer<typeof auditLog>;

export const createAuditLogInput = z.object({
  organizationId,
  actorUserId: id.nullish(),
  action: z.string().min(1),
  entityType: z.string().min(1),
  entityId: id.nullish(),
  previousValue: z.record(z.string(), z.unknown()).nullish(),
  newValue: z.record(z.string(), z.unknown()).nullish(),
  ipAddress: z.string().nullish(),
});
export type CreateAuditLogInput = z.infer<typeof createAuditLogInput>;
